// extracted by mini-css-extract-plugin
export default {"button":"styles_button__Ip8mG","icon":"styles_icon__G08Y3"};